export const STAKE_HELMET_TITLE =
  'FusionX | Decentralized Exchange | Stake'
export const STAKE_HELMET_DESCRIPTION =
  "One-stop Decentralized Trading Platform. Trade and discover thousands of tokens. Stake tokens for rewards. Fully decentralized. Welcome to FusionX everyone's favourite DEX."
